// extracted by mini-css-extract-plugin
module.exports = {"link":"_3vckfz","shine-lines":"_9A_qjx"};